import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const ITEMS = [
  "Fair play guaranteed",
  "Ages 6+",
  "No ads. Ever.",
  "Learn as you play",
  "New questions weekly",
  "Made for every age",
  "Zero sore losers",
];

export const MarqueeStrip = () => (
  <div
    data-testid="marquee-strip"
    className="-rotate-1 border-y-2 border-[#1A1D1E] bg-[#FFC837] py-4"
  >
    <Marquee speed={35} gradient={false} aria-hidden="true">
      {ITEMS.map((item) => (
        <span
          key={item}
          className="mx-6 flex items-center gap-12 font-display text-2xl font-semibold tracking-tight text-[#1A1D1E] md:text-3xl"
        >
          {item}
          <Star className="h-6 w-6 fill-[#1A1D1E]" />
        </span>
      ))}
    </Marquee>
  </div>
);
